<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="loanShop.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
                @blur="$emit('on-name-change', loanShop.name)"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            loanShop: {}
        };
    },

    watch: {
        loanShop() {
            this.$emit('input', this.loanShop);
        }
    },

    mounted() {
        this.loanShop = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.loanShop[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.loanShop,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
